import { Dialog, isWeb, useSafeArea } from '@my/ui'

type GroupCreationModalProps = {
  open: boolean
  onOpenChange?: (value) => void
  children: React.ReactNode
}

export const GroupCreationModal = ({ open, children }: GroupCreationModalProps) => {
  const { top } = useSafeArea()

  const insets = isWeb ? { pt: '$3.5' } : { pt: top, pb: 0 }

  return (
    <Dialog modal open={open}>
      <Dialog.Portal zIndex="$2" h="100%" {...insets}>
        <Dialog.Overlay
          key="overlay"
          animation="quick"
          bg="$overlay8"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />

        <Dialog.Content
          width="100%"
          maxWidth={600}
          height="100%"
          borderRadius="$3"
          key="content"
          bg="$white"
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          y={0}
          opacity={1}
          enterStyle={{ opacity: 0, y: 100 }}
          exitStyle={{ opacity: 0, y: 100 }}
          $gtXs={{
            maxHeight: 600,
          }}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
